// Legacy mock auth bridge → uses real AuthContext under the hood.
// Pages that still call these helpers will get the right behaviour.
import { apiAuth, setToken } from "./api";

export const getSession = () => {
  const t = localStorage.getItem("grabb_token");
  if (t) return { kind: "user" };
  if (sessionStorage.getItem("grabb_guest") === "1") return { kind: "guest" };
  return null;
};
export const isAuthed = () => !!localStorage.getItem("grabb_token");
export const isGuest = () => sessionStorage.getItem("grabb_guest") === "1";

export const signInAsGuest = () => {
  sessionStorage.setItem("grabb_guest", "1");
};

// Used by mock-only Login/Register before — now no-op stubs since real auth handles it.
export const signInAsUser = () => {};
export const clearSession = async () => {
  try { await apiAuth.logout(); } catch {}
  setToken(null);
  sessionStorage.removeItem("grabb_guest");
};
export const setSession = () => {};
